function EditIcon() {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Iconly/Light/Edit Square">
        <g id="Edit Square">
          <path
            id="Stroke 1"
            d="M10.0769 2.32422H6.96104C4.39854 2.32422 2.79187 4.13839 2.79187 6.70672V13.6351C2.79187 16.2034 4.39104 18.0176 6.96104 18.0176H14.3144C16.8852 18.0176 18.4844 16.2034 18.4844 13.6351V10.2784"
            stroke="#4558FF"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Stroke 3"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.8564 9.10074L14.0839 2.87324C14.8597 2.09824 16.1172 2.09824 16.8931 2.87324L17.9072 3.88741C18.6831 4.66324 18.6831 5.92158 17.9072 6.69658L11.6497 12.9541C11.3106 13.2932 10.8506 13.4841 10.3706 13.4841H7.2489L7.32723 10.3341C7.3389 9.87074 7.52807 9.42908 7.8564 9.10074Z"
            stroke="#4558FF"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Stroke 5"
            d="M13.1376 3.83545L16.9426 7.64045"
            stroke="#4558FF"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
}

export default EditIcon;
